import React, { useCallback, useEffect, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import css from './Notification.module.scss'

export const DEFAULT_DELAY: number = 3000;

interface INotificationContext {
    setNotice: (notice: React.ReactNode) => void;
    setDelay: (delay: number | null) => void;
    onClose: () => void;
}

export const NotificationContext = React.createContext<INotificationContext>({
    setNotice: () => {},
    setDelay: () => {},
    onClose: () => {},
});

type Props = {
    children: React.ReactNode;
    bg?: "highlight" | "primary" | "danger";
    delay?: number;
}

const NotificationProvider = ({ children, bg }: Props) => {
    const [notice, setNotice] = useState<React.ReactNode | null>(null);
    const [delay, setDelay] = useState<number | null>(DEFAULT_DELAY);

    const onClose = useCallback(() => setNotice(null), [setNotice]);

    //TODO : set Delay and bg customisable by provider context, maybe better to move Toast to external component
    return (
        <NotificationContext.Provider value={{setNotice, setDelay, onClose}}>
            {children}
            <AppToast>
                <Toast onClose={onClose} show={!!notice} delay={!!delay ? delay : undefined} autohide={!!delay} bg={!!bg ? bg : "highlight"}>
                    <Toast.Body>
                        {notice}
                    </Toast.Body>
                </Toast>
            </AppToast>
        </NotificationContext.Provider>
    );
}



function getToastPortal() {
    const toastContainer = document.querySelector('#toastPortal');
    if(!toastContainer) {
      const newToastContainer = document.createElement('div');
      newToastContainer.id = 'toastPortal';
      document.body.appendChild(newToastContainer);
      return newToastContainer;
    }
    return toastContainer;
}

function AppToast({ children, onClose, show, delay, autohide, bg }: any) {
    const [showToast, setShowToast] = useState(show);
    useEffect(() => {
      setShowToast(true);
    }, []);
  
    if(!showToast) return null;''
  
    return createPortal(
      <ToastContainer className={`${css.appToast} p-3`}>
        {children}
      </ToastContainer>,
      getToastPortal()
    )
  }

export default NotificationProvider;